import GiftCardCategory from './screens/category/'
import Occasions from './screens/occasions'
import Categories from './screens/categories'
import CartSummary from './screens/cart-summary'
import Success from './screens/success'
import GenericError from './screens/error/generic-error'
import TxnError from './screens/error/txn-error'
import PromotionError from './screens/error/promotion-error'
import OrderConfirmation from './screens/order-confirmation'
import Businesses from './screens/businesses'
import BusinessesSearch from './screens/businesses/BusinessesSearch'

import {
  Home,
  BundlesWithData,
  CardsWithData,
  Deals,
  SearchResults,
  CustomBundles,
  CustomBundlesCart,
} from './pages'

const routes = [
  {
    path: '/',
    exact: true,
    component: Home,
    pgrp: 'main:consumer:gifts:home:::',
  },
  {
    path: '/all',
    exact: true,
    component: CardsWithData,
    pgrp: 'main:consumer:gifts:allcards:::',
  },
  {
    path: '/bundles',
    exact: true,
    component: BundlesWithData,
    pgrp: 'main:consumer:gifts:bundles:::',
  },
  {
    path: '/byob',
    exact: true,
    component: CustomBundles,
    pgrp: 'main:consumer:gifts:bundles:byo::',
  },
  {
    path: '/byob/add',
    exact: true,
    component: CustomBundlesCart,
    pgrp: 'main:consumer:gifts:bundles:byo:addtocart:',
  },
  {
    path: '/deals',
    exact: true,
    component: Deals,
    pgrp: 'main:consumer:gifts:deals:::',
  },
  {
    path: '/deals/:dealsName',
    exact: true,
    component: Deals,
    pgrp: 'main:consumer:gifts:deals:::',
  },
  {
    path: '/occasions',
    exact: true,
    component: Occasions,
  },
  {
    path: '/categories',
    exact: true,
    component: Categories,
  },
  {
    path: '/business/search',
    exact: true,
    component: BusinessesSearch,
  },
  {
    path: '/business',
    exact: true,
    component: Businesses,
  },
  {
    path: '/(categories|occasions)/:name',
    exact: true,
    component: GiftCardCategory,
  },
  {
    path: '/search/:type',
    exact: true,
    component: SearchResults,
    pgrp: 'main:consumer:gifts:search:::',
  },
  {
    path: '/search',
    exact: true,
    component: SearchResults,
    pgrp: 'main:consumer:gifts:search:::',
  },
  {
    path: '/cartsummary',
    exact: true,
    component: CartSummary,
    pgrp: 'main:consumer:gifts:cartsummary:::',
  },
  {
    path: '/success',
    exact: true,
    component: Success,
    pgrp: 'main:consumer:gifts:success:::',
  },
  {
    path: '/error',
    exact: true,
    component: GenericError,
    pgrp: 'main:consumer:gifts:error:::',
  },
  {
    path: '/txnerror',
    exact: true,
    component: TxnError,
    pgrp: 'main:consumer:gifts:txnerror:::',
  },
  {
    path: '/promotionerror',
    exact: true,
    component: PromotionError,
    pgrp: 'main:consumer:gifts:promotionerror:::',
  },
  {
    path: '/confirmation',
    exact: true,
    component: OrderConfirmation,
    pgrp: 'main:consumer:gifts:confirmation:::',
  },
]

export default routes
